import React from "react";
import { Link } from "react-router-dom";
import { Button, Result } from "antd";

function UnderDevelopment() {
  return (
    <Result
      status="500"
      title="Üzgünüz, sistem geliştirme aşamasındadır."
      subTitle=""
      extra={
        <Link to="/">
          <Button type="primary">Geri Dön</Button>
        </Link>
      }
    />
  );
}

export default UnderDevelopment;



// WEBPACK FOOTER //
// ./src/component/UnderDevelopment/index.js